import { configureStore } from '@reduxjs/toolkit';

import offerReducer from './Features/offers/OfferSlice';
import eventReducer from './Features/Events/EventSlice';
import cartReducer from '../src/Features/services/cartSlice';
import guestCartReducer from '../src/Features/services/guestCartSlice';
import offersReducer from '../src/Features/Offer/offerSlice';
import authReducer from './Features/Auth/AuthSlice';
import messageReducer from '../src/Features/message/messageSlice';
import currentEventReducer from './Features/Events/currentEventSlice';
import { api } from './Api/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    offers: offerReducer,
    events: eventReducer,
    currentEvent: currentEventReducer,
    cart: cartReducer,
    guestCart: guestCartReducer,
    offer: offersReducer,
    message: messageReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});
